import { Helmet } from '@dr.pogodin/react-helmet';
import type { PropsWithChildren } from 'react';

import styles from './layout.module.css';

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <main id="content" className={styles['main']}>
      <Helmet>
        <meta
          name="description"
          content="Search live menus. Order cannabis online."
        />
      </Helmet>
      {children}
    </main>
  );
};
